<template>
  <div class="r-input-box" @click="chooseCtm">
    <div class="iconfont iconwancheng" v-if="ctmShow"></div>
    <textarea
      class="input-box common-rowUnder"
      :placeholder="$t('pleaseIpt')"
      type="text"
      @focus="focus"
      @blur="onBlur"
      v-model="value"
    ></textarea>
    <div class="box"></div>
    <div class="name">CMT</div>
  </div>
</template>

<script>
export default {
  name: "r-inputbox",
  data() {
    return {
      value: "",
      ctmShow:false
    };
  },
  watch: {
    value: {
      handler(newval) {
        // console.log('newval',newval)
        // this.value = newval
        this.$emit("iptValue", newval);
      },
      immediate: true,
    },
    iptFabric: {
      handler(newval) {
        this.value = newval;
      },
      immediate: true,
    },
    checks: {
      handler(newval) {
        console.log('newval',newval)
        // if(newval){
          this.ctmShow = newval;
        // }
      },
      immediate: true,
      deep:true
    },
  },
  props: {
    iptFabric: [String, Number],
    checks:Boolean,
  },
  methods: {
    focus() {
      // console.log('focus')
      // this.$emit("fabricFocus");
    },
    onBlur() {
      this.$emit("fabricFocus");
    },
    // 选择ctm
    chooseCtm(){
      this.ctmShow = true
      this.$emit("chooseCtm",this.ctmShow);

    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-input-box {
  // margin: 0 5px 15px;
  margin-right: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  position: relative;
  .iconwancheng {
    position: absolute;
    font-size: 24px;
    color: #003888;
    background: #fff;
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    top: 25px;
    opacity: 0.7;
    z-index: 99;
    left: 0;
    right: 0;
    margin: auto;
  }
  .box {
    // width: 78px;
    // height: 78px;
    // border: 1px solid #003888;
    // position: absolute;
    // top: -2px;
    // left:-2px;
    // border-radius: 5px;
  }

  .input-box {
    width: 74px;
    height: 74px;
    border: 1px solid rgba(8, 25, 56, 0.3);
    resize: none;
    outline: none;
    padding: 9px 8px;
    border-radius: 5px;
    position: relative;
    z-index: 9;
  }
  .input-box::-webkit-input-placeholder {
    font-size: 12px;
    // transform: scale(.7);
  }
  .name {
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #081938;
    line-height: 14px;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-inputbox.vue